<template>
  <div class="entry-container mb-3 pointer" @click="$router.push({ name: 'entry', params: { id: entry.id } })">
    <div class="entry-grid text-center-1">
      <div class="entry-grid__item entry-grid__item--name" data-label="Nombre">{{ entry.text }}</div>
      <div class="entry-grid__item" data-label="Fecha inicio">{{ fullDate }}</div>
      <div class="entry-grid__item" data-label="Fecha fin">{{ fullDateFin }}</div>
      <div class="entry-grid__item" data-label="Monto">{{ entry.monto }}</div>
      <div class="entry-grid__item" data-label="Deuda">{{ entry.deuda }}</div>
      <div class="entry-grid__item" data-label="Dias restantes">
        <p :class="computedClasses">{{ daysSinceLastDate }} Dias {{ computedState }}</p>
      </div>
    </div>
  </div>
</template>

<script>
const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
const days = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado']

export default {
  props: {
    entry: {
      type: Object,
      requiered: true
    }
  },
  computed: {
    shortText() {
      return this.entry.text.length > 140
        ? this.entry.text.substring(0, 130) + '...'
        : this.entry.text
    },
    day() {
      const date = new Date(this.entry.date)
      return date.getDate()
    },
    month() {
      const date = new Date(this.entry.date)
      return months[date.getMonth()]
    },
    yearDay() {
      const date = new Date(this.entry.date)
      return `${date.getFullYear()}, ${days[date.getDay()]}`
    },
    fullDate() {
      const date = new Date(this.entry.date)
      if (date === null) {
        return 'Sin fecha'
      }
      return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()} `
    },
    fullDateFin() {
      const date2 = new Date(this.entry.dateFin)
      if (isNaN(date2)) {
        return 'Sin fecha'
      }
      return `${date2.getDate()}-${date2.getMonth() + 1}-${date2.getFullYear()} `
    },
    daysSinceLastDate() {
      const currentDate = new Date()
      currentDate.setHours(0, 0, 0, 0)
      const previousDate = new Date(this.entry.dateFin)
      previousDate.setHours(0, 0, 0, 0)
      const timeDifference = previousDate.getTime() - currentDate.getTime()
      const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24))
      const adjustedValue = daysDifference < 0 ? 0 : daysDifference
      if (isNaN(adjustedValue)) {
        return '0'
      }
      return adjustedValue
    },
    computedClasses() {
      return {
        class1: this.daysSinceLastDate >= 4 && this.daysSinceLastDate <= 6,
        class2: this.daysSinceLastDate <= 3,
        class3: this.daysSinceLastDate
      }
    },
    computedState() {
      return this.daysSinceLastDate === 0 ? 'se termino' : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.entry-container {
  border-bottom: 1px solid #2c3e50;
  border-radius: 12px;
  padding: 0.5rem var(--entry-grid-padding-x, 0.75rem);
  transition: 0.2s all ease-in;

  &:hover {
    background-color: lighten($color: grey, $amount: 45);
    transition: 0.2s all ease-in;
  }
}

.entry-grid {
  display: grid;
  grid-template-columns: var(--entry-grid-columns, minmax(160px, 2fr) repeat(5, minmax(90px, 1fr)));
  gap: var(--entry-grid-gap, 0.5rem);
  align-items: center;
}

.entry-grid__item {
  overflow-wrap: anywhere;
}

.entry-grid__item--name {
  font-weight: 700;
}

.text-center-1 {
  text-align: center;
}

.class2 {
  font-weight: 800 !important;
  color: red !important;
  background: antiquewhite;
  border-radius: 50px;
}

.class3 {
  font-weight: 800 !important;
  color: #000;
}

.class1 {
  font-weight: 800 !important;
  color: orange !important;
  background: antiquewhite;
  border-radius: 50px;
}

@media (max-width: 900px) {
  .entry-grid {
    grid-template-columns: 1fr 1fr;
    text-align: left;
  }

  .entry-grid__item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.2rem;
    padding: 0.25rem 0;
  }

  .entry-grid__item::before {
    content: attr(data-label);
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #0b819b;
  }
}
</style>
